/**
 * Dialog components - ported from D:\Food for thunderbee stock pages
 * Uses Ant Design Modal with thunderbee primary color #E13F57
 */
import React from "react";
import { Modal } from "antd";

const PRIMARY_COLOR = "#E13F57";

export function ErrorDialog({
  isOpen,
  onClose,
  title = "เกิดข้อผิดพลาด",
  message,
  type = "error",
  confirmText = "ตกลง",
  onConfirm,
}) {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    if (onClose) onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onOk={handleConfirm}
      okText={confirmText}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { background: PRIMARY_COLOR, borderColor: PRIMARY_COLOR } }}
      title={title}
      centered
    >
      {message && (
        <p style={{ whiteSpace: "pre-line", marginBottom: 0 }}>{message}</p>
      )}
    </Modal>
  );
}

export function SuccessDialog({
  isOpen,
  onClose,
  title = "สำเร็จ",
  description = "",
  confirmText = "ตกลง",
}) {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onOk={onClose}
      okText={confirmText}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { background: PRIMARY_COLOR, borderColor: PRIMARY_COLOR } }}
      title={title}
      centered
    >
      {description && <p style={{ marginBottom: 0 }}>{description}</p>}
    </Modal>
  );
}

export function ConfirmDialog({
  isOpen,
  onClose,
  title,
  message,
  confirmText = "ยืนยัน",
  cancelText = "ยกเลิก",
  onConfirm,
  type = "warning",
}) {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    if (onClose) onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onOk={handleConfirm}
      okText={confirmText}
      cancelText={cancelText}
      okButtonProps={{ style: { background: PRIMARY_COLOR, borderColor: PRIMARY_COLOR } }}
      title={title}
      centered
    >
      {message && (
        <p style={{ whiteSpace: "pre-line", marginBottom: 0 }}>{message}</p>
      )}
    </Modal>
  );
}
